'use client'
import { useListAccountNoticesQuery } from '@web/gen/user'
import * as React from 'react'
import { Toast } from '@web/components/toaster'
import type { MyAccountNotice } from 'codegen/types'

export function MyAccountNotices() {
  const { data, isPending } = useListAccountNoticesQuery()
  const [notices, setNotices] = React.useState<(MyAccountNotice & { id: string })[]>([])

  React.useEffect(() => {
    if (!data?.listAccountNotices?.notices) {
      return
    }
    setNotices(prev => {
      const existingKeys = new Set(prev.map(n => n.message + n.type))
      const newOnes = data.listAccountNotices.notices
        .filter(n => !existingKeys.has(n.message + n.type))
        .map(n => ({
          id: crypto.randomUUID(),
          message: n.message,
          type: n.type as MyAccountNotice['type'],
        }))
      return [...prev, ...newOnes]
    })
  }, [data])

  const dismissNotice = (id: string) => {
    setNotices(prev => prev.filter(n => n.id !== id))
  }

  if (isPending || notices.length === 0) {
    return null
  }

  return (
    <div className="flex flex-col gap-4">
      {notices.map(({ id, message, type }) => (
        <Toast
          key={id}
          message={message}
          type={type as 'error' | 'success' | 'notice' | 'loading'}
          onClose={() => dismissNotice(id)}
          standalone
        />
      ))}
    </div>
  )
}
